export const authDestination = search => {
  const params = new URLSearchParams(search);
  const requested = params.get('returnTo');
  const safe = requested && /^\/intelligence(?:[/?]|$)/.test(requested) && !requested.startsWith('/intelligence/auth') && !requested.includes('\\');
  if (safe) return requested;
  const query = params.get('query');
  return query ? `/intelligence?query=${encodeURIComponent(query)}` : '/intelligence';
};